import { ajax } from '@/plugins/ajax';

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
        fetchFilterPanel({ commit }, { menuId, contractId }) {
            return new Promise((resolve, reject) => {
                ajax.get('CMS/api/MenusFilterPanelQuery?menuId=' + menuId + '&contractId=' + contractId)
                    .then((r) => {
                        resolve(r.data);
                    })
                    .catch((e) => reject(e));
            });
        },
        fetchProducts({ commit }, { queryParams }) {
            return new Promise((resolve, reject) => {
                ajax.get('CMS/api/MenuProductsQuery/0?' + queryParams)
                    .then((r) => {
                        resolve(r);
                    })
                    .catch((e) => reject(e));
            });
        }
    },
    mutations: {
    }
};
